import baseTheme from './themes/base.scss';
import karmadataTheme from './themes/karmadata.scss';
import KdSelectNumber from './components/KdSelectNumber';
import KdSelectEntity from './components/KdSelectEntity';
import KdSelectEntityMultiple from './components/KdSelectEntityMultiple';
import KdSelectString from './components/KdSelectString';
import kdSelectStringMultiple from './components/KdSelectString';
import KdSelectDate from './components/KdSelectDate';
import kdWrapper from './kdWrapper';

const KdUi = {
  KdSelectString: kdWrapper(KdSelectString),
  kdSelectEntity: kdWrapper(KdSelectEntity),
  kdSelectEntityMultiple: kdWrapper(KdSelectEntityMultiple),
  kdSelectNumber: kdWrapper(KdSelectNumber),
  kdSelectString: kdWrapper(KdSelectString),
  kdSelectStringMultiple: kdWrapper(kdSelectStringMultiple),
  kdSelectDate: kdWrapper(KdSelectDate),
  themes: { kd: karmadataTheme, base: baseTheme },
};

window.KdUi = KdUi;
module.exports = KdUi;



// WEBPACK FOOTER //
// ./app/index-cdn.js